import React, { useEffect } from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

function Login() {
  const navigate = useNavigate();
  const auth = useAuth();
  const location = useLocation();
  // Determine the path to redirect to after successful login
  // Defaults to '/' if no 'from' state is present (e.g., direct access to /login)
  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    // If the user is already authenticated, redirect them to the intended page
    if (auth.isAuthenticated) {
      console.log("Login.tsx: User is authenticated, navigating to:", from);
      navigate(from, { replace: true });
    } else if (!auth.isLoading) { // User is not authenticated and not currently loading
      if (auth.error) {
        // An error already exists from a previous attempt.
        // Avoid an immediate automatic redirect to prevent potential loops if signinRedirect consistently fails.
        // The main App component or a dedicated error display should handle showing this error.
        console.error(
          "Login.tsx: Authentication error detected. Not re-initiating signinRedirect immediately. Error:",
          auth.error
        );
        // Optionally, you could navigate to an error page or display a message here.
      } else {
        // No existing error, attempt sign-in
        console.log("Login.tsx: Attempting to redirect to signin...");
        auth.signinRedirect({ state: { returnUrl: from } })
          .catch(err => console.error("Error during signinRedirect in Login.tsx:", err));
      }
    }
  }, [auth.isAuthenticated, auth.isLoading, navigate, from, auth]); // Add auth to dependencies

  // While the redirect is happening, display a loading message
  return (
    <Stack direction="column" justifyContent="center" alignItems="center" spacing={2} sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
      <Typography>Redirecting to login...</Typography>
    </Stack>
  );
}

export default Login;